exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reported-comm.recommend-list .search-name-wrap .btn-stage{overflow:hidden}.delet-pop .form-cont{font-size:16px;text-align:center}.type-drop{margin-right:10px}.key-drop{border-radius:4px 0 0 4px!important}.key-input .input-box-wrap,.key-input .input-box-wrap .edit-box input{border-left:none;border-radius:0 4px 4px 0!important}.table-data-stage .table-cell.td-width{max-width:120px;word-break:break-all;white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/community/common-recommend/recommend-list/recommend-list.scss
// module id = 514
// module chunks = 2